export class StoreModel {
  storeId: number = 0;
  branchId: number = 0;
  inventoryId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  name: string = '';
  active: boolean = true;
  occupancyPercentageReport: boolean = true;
  costCenterCode: string | null = null;
  ownStore: boolean = true;
  swMandate: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
